module.exports = __webpack_public_path__ + "static/media/griffith_dark.25003f61.png";